export class ConfirmDialog extends HTMLElement {
  constructor() {
    super();
    this._resolve = null;
  }

  connectedCallback() {
    this.addEventListener('click', (e) => {
      if (e.target === this) this._resolve(false);
    });
    this.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') this._resolve(false);
    });
  }

  static show({ title, message, confirmText = 'Delete', cancelText = 'Cancel', variant = 'danger' } = {}) {
    return new Promise((resolve) => {
      const existing = document.querySelector('confirm-dialog');
      if (existing) existing.remove();

      const el = document.createElement('confirm-dialog');
      el._resolve = resolve;
      el.innerHTML = `
        <div class="confirm-overlay">
          <div class="confirm-dialog">
            <div class="confirm-header">
              <h3>${title}</h3>
            </div>
            <div class="confirm-body">
              <p>${message}</p>
            </div>
            <div class="confirm-footer">
              <button class="btn btn-secondary" data-action="cancel">${cancelText}</button>
              <button class="btn btn-${variant}" data-action="confirm">${confirmText}</button>
            </div>
          </div>
        </div>
      `;

      el.querySelector('[data-action="cancel"]').addEventListener('click', () => resolve(false));
      el.querySelector('[data-action="confirm"]').addEventListener('click', () => resolve(true));

      el.addEventListener('threatscope:confirm-close', () => resolve(false));

      document.body.appendChild(el);
      el.focus();

      const dialogEl = el.querySelector('.confirm-dialog');
      requestAnimationFrame(() => {
        dialogEl.classList.add('confirm-enter');
      });
    }).finally(() => {
      const d = document.querySelector('confirm-dialog');
      if (d) d.remove();
    });
  }
}

customElements.define('confirm-dialog', ConfirmDialog);
